import { Button } from "@mui/material";
import React from "react";

function StyledButton({ name }) {
  return <Button variant="outlined">{name}</Button>;
}

export default StyledButton;
